// extracted by mini-css-extract-plugin
export default {"productGallery":"XN-z","inQuickShop":"YN-z"};